import { Component, Inject, Injectable } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface ConfirmDialogData {
	title: string;
	message?: string;
	ok_label?: string;
	cancel_label?: string;
	/** Paints the confirm button in the warn color, for actions that remove or give something away. */
	is_destructive?: boolean;
}

/**
 * NDS3 confirmation dialog (Material), replacing native confirm(). Strings arrive translated.
 */
@Component({
	selector    : 'app-confirm-dialog',
	templateUrl : './confirm-dialog.component.html',
	styles      : ['.confirm-dialog__message { margin: 0; white-space: pre-line; }'],
})
export class ConfirmDialogComponent {
	constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData)
	{
	}
}

@Injectable({ providedIn : 'root' })
export class ConfirmDialogService {
	constructor(private dialog: MatDialog)
	{
	}

	confirm(data: ConfirmDialogData): Observable<boolean>
	{
		return this.dialog.open(ConfirmDialogComponent, { data, width : '440px', autoFocus : 'dialog' })
			.afterClosed()
			.pipe(map(result => result === true));
	}
}
